<template>
  <div>
    <v-card>
      <v-card-title class="headline">Подгрузка тезисов
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" lg="6">
            <v-card class="pa-4">
              <v-row>
                <v-col>
                  <v-textarea
                    :maxlength="250"
                    counter
                    outlined
                    rows="3"
                    v-model="thesis.name"
                    :error="name_len_error"
                    label="Название доклада"
                  ></v-textarea>
                </v-col>
              </v-row>

              <v-row class="pl-4 pr-4">
                <div class="d-flex flex-nowrap">
                  <v-icon>mdi-city</v-icon>Организации
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="green lighten-1"
                        @click="add_org_dialog=true;"
                        style="margin-left: 8px !important;">
                        mdi-plus
                        </v-icon>
                    </template>
                    <span>добавить</span>
                  </v-tooltip>
                </div>
              </v-row>
              <v-row class="pl-4 pr-4" v-for="(org, i) in thesis.orgs" :key="org.descr">
                <v-col cols="12" style="margin: auto;" class="pa-0 d-flex flex-nowrap ">
                  <p class="ml-12">
                    <!-- <v-icon>mdi-badge-account-outline</v-icon> -->
                    {{org.view_descr}}
                  </p>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="red lighten-1"
                        @click="delete_from_orgs(i)"
                        style="margin-top: -16px !important; margin-left: 8px !important;">
                        mdi-delete
                      </v-icon>
                    </template>
                    <span>удалить</span>
                  </v-tooltip>
                </v-col>
              </v-row>

<!-- 

              <v-row v-for="org, id in thesis.orgs" :key="org.name">
                <v-col cols="12" class="pt-0 pb-0">
                  <v-text-field
                    v-model="org.descr"
                    label="Литература"
                    required>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="5" class="pt-2 pb-0">
                  <v-btn color="green darken-1"
                    @click="add_org_dialog=true">{{"добавить"}}
                  </v-btn>
                </v-col>
              </v-row>
 -->
            <v-row class="pa-4">
              <v-divider></v-divider>

            </v-row>

            <v-row class="pl-4 pt-4">
              <v-col cols="5" >
                <v-text-field
                  v-model="thesis.author.fio"
                  label="Докладчик (Фамилия Имя Отчество полностью)"
                  :error="thesis.author.fio.length == 0"
                  required>
                </v-text-field>

              </v-col>
              <v-col class="pt-4" cols="7">
                <div class="input-container input-name modal-mul-select">
                  <v-select
                    v-model="thesis.author.org_numbers"
                    :items="thesis.orgs"
                    item-text="view_descr"
                    item-value="id"
                    multiple
                    chips
                    dense
                    :label="thesis.orgs.length > 0 ? 'Организация' : 'Добавьте организации выше'"
                    required
                    :error="!thesis.author.org_numbers || thesis.author.org_numbers.length == 0"
                  ></v-select>
                </div>

              </v-col>
            </v-row>

            <v-row class="pl-4 pt-4" v-for="ca in thesis.coautors" :key="ca.id">
              <v-col cols="5" >
                <v-text-field
                  v-model="ca.fio"
                  label="Соавтор (Фамилия Имя Отчество полностью)"
                  :error="ca.fio.length == 0"
                  required>
                </v-text-field>

              </v-col>
              <v-col class="pt-4" cols="7">
                <div class="input-container input-name modal-mul-select">
                  <v-select
                    v-model="ca.org_numbers"
                    :items="thesis.orgs"
                    item-text="view_descr"
                    item-value="id"
                    multiple
                    chips
                    dense
                    :label="thesis.orgs.length > 0 ? 'Организация' : 'Добавьте организации выше'"
                    required
                    :error="!ca.org_numbers || ca.org_numbers.length == 0"
                  ></v-select>
                </div>

              </v-col>
            </v-row>
            <v-row class="pl-4 pt-4">
              <v-col cols="6">
                <v-btn small color="green" 

                  @click="add_coautor()">{{"добавить соавтора"}}
                </v-btn>
              </v-col>
              <v-col cols="6"></v-col>
            </v-row>

            <v-row class="pl-4 pt-4">
              <v-col cols="7" class="pt-0 pb-0">
                <v-text-field
                  v-model="thesis.email"
                  label="E-mail"
                  :error="email_len_error"
                  required>
                </v-text-field>
              </v-col>
              <v-col cols="5" class="pt-2 pb-0">
              </v-col>
            </v-row>



              <v-row style="margin-bottom: -20px !important;">
                <v-col>
                  <v-textarea
                    outlined
                    :maxlength="3500"
                    counter
                    rows="8"
                    :error="text_len_error"
                    v-model="thesis.text"
                    label="Тезисы * (минимальное количество символов - 1500 знаков с пробелами)"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row style="margin-left: 12px !important; margin-top: 0px !important;">
                <p> *для выделения текста курсивом используйте тег: &lt;i&gt;<i style="font-style: italic;">текст курсивом</i>&lt;/i&gt; </p>
              </v-row>

              <v-row>
                <v-col>
                  <v-textarea
                    outlined
                    counter
                    :maxlength="400"
                    rows="3"
                    v-model="thesis.finance"
                    label="Финансовая поддержка"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row v-for="lit_descr, id in thesis.lit" :key="'lit'+id">
                <v-col cols="12" class="pt-0 pb-0">
                  <v-text-field
                    v-model="thesis.lit[id]"
                    label="Литература"
                    required>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="thesis.lit.length < 5">
                <v-col cols="5" class="pt-2 pb-0">
                  <v-btn color="green darken-1"
                    @click="add_lit()">{{"добавить"}}
                  </v-btn>
                </v-col>
              </v-row>

            </v-card>

          </v-col>
          <v-col cols="12" lg="6">
            <v-card>
              <v-card-text style="text-align: center; font-size: 16px;">
                <b>{{ thesis.name }}</b>
              </v-card-text>
              <v-card-text style="text-align: center; font-size: 16px;">
                <u><b>{{ thesis.author.fio }}</b></u>
                <sup v-if="thesis.orgs.length > 1">
                  <!-- <b v-for="org_num in thesis.author.org_numbers"> {{ (org_num).toString() }}, </b> -->

                  <b v-if="thesis.author.org_numbers && thesis.author.org_numbers.length > 0"> {{ (thesis.author.org_numbers[0]).toString() }}</b>
                    <template v-if="thesis.author.org_numbers && thesis.author.org_numbers.length > 1">
                      <b v-for="org_num, id in thesis.author.org_numbers" v-if="id > 0">,{{ (org_num).toString() }}</b>
                    </template>
                </sup>
                <b v-for="co in thesis.coautors">, {{ co.fio }}
                  <sup v-if="thesis.orgs.length > 1">
                    <b v-if="co.org_numbers && co.org_numbers.length > 0"> {{ (co.org_numbers[0]).toString() }}</b>
                    <template v-if="co.org_numbers && co.org_numbers.length > 1">
                      <b v-for="org_num, id in co.org_numbers" v-if="id > 0">,{{ (org_num).toString() }}</b>
                    </template>
                    <!-- <template v-else>

                    </template> -->
                  </sup>
                </b>
              </v-card-text>
              <v-card-text class="pa-0" v-for="org, id in thesis.orgs" style="text-align: center; font-size: 14px;" :key="'orgs_'+id">
                <p class="mb-0" style="font-style: italic;">
                  <sup v-if="thesis.orgs.length > 1">{{ (id + 1).toString() }}</sup>{{ org.descr }}<i v-if="id == 0"  style="font-style: italic;">, {{ thesis.email }}</i>
                </p>
              </v-card-text>

              <v-card-text v-html="view_thesis" style="text-indent: 20px; text-align: justify;"></v-card-text>
              <!-- <p>
                {{ view_thesis }}
              </p> -->
              <v-card-text  style="text-indent: 20px; text-align: justify;">
                {{ thesis.finance }}
              </v-card-text>

              <v-card-text style="text-align: center; font-size: 16px;" class="pb-0">
                <b>Литература</b>
              </v-card-text>
              <v-card-text class="pa-0" v-for="lit_descr,id in thesis.lit" :key="id" style="text-indent: 20px; text-align: justify;font-size: 12px;">
                <p v-if="lit_descr.length > 0" class="mb-0">{{ (id+1).toString() }}. {{ lit_descr }}</p>            
              </v-card-text>
           
              <v-card-text>
                <p></p>
              </v-card-text>

            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="clear_data(); $emit('updateParent', -1)">отмена</v-btn>
        <v-btn color="green darken-1" text
          @click="upload_thesis()">{{"Загрузить"}}
        </v-btn>
      </v-card-actions>

    </v-card>

    <v-dialog v-model="add_org_dialog" max-width="700px">
      <v-card>
        <v-card-title class="headline">добавить организацию
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12" lg="10">
              <v-row>
                <v-col cols="12" lg="8">
                  <v-autocomplete
                    v-model="valueOrganization"
                    :items="organizations"
                    item-value="id"
                    item-text="name"
                    label='Научная организация'
                    prepend-icon="mdi-city"
                    :error="valueOrganization_error"
                  ></v-autocomplete>
                </v-col>
                <v-col class="pt-8" cols="12" lg="4">
                  <v-checkbox
                    class="mt-0"
                    :color="$mainColor"
                    v-model="checkbox_other_org"
                    label="другая"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row style="margin-top: -20px">
                <v-col class="pt-0" cols="12">
                  <v-text-field
                    class="mt-0"
                    v-if="checkbox_other_org"
                    v-model="other_org_descr"
                    placeholder="название организации"
                    label="название организации"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" lg="2" class="pa-0 pt-8">
              <v-btn color="green darken-1" text  class="pa-0"
                @click="add_org_to_thesis()">{{"Добавить"}}
              </v-btn>

            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text>
          <v-row v-for="(org, i) in thesis.orgs" :key="org.descr">
            <v-col cols="12" style="margin: auto;" class="pa-0 d-flex flex-nowrap ">
              <p class="ml-12">
                <!-- <v-icon>mdi-badge-account-outline</v-icon> -->
                {{org.view_descr}}
              </p>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="red lighten-1"
                    @click="delete_from_orgs(i)"
                    style="margin-top: -16px !important; margin-left: 8px !important;">
                    mdi-delete
                  </v-icon>
                </template>
                <span>удалить</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="add_org_dialog = false">готово</v-btn>
          <!-- <v-btn color="green darken-1" text
            @click="add_org_to_thesis()">{{"Добавить"}}
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>
<script>
// import { validationMixin } from 'vuelidate';
// import { required, maxLength, email } from 'vuelidate/lib/validators';
import { mapActions, mapGetters, mapMutations } from 'vuex';
// import { parserDate, parserString } from '../../helpers/parserDate';
// import { AUTH_URL, REFERENCES_URL, USER_URL } from '../../../vars';
// import user from '../../assets/user.png';

export default {
  mounted() {
    // this.uploadDataUser();
  },

  async beforeMount() {
      this.organizations = this.GETTERS_ORGS
  },

  name: 'ThesisUpload',

  props: {
    current_user_registration_id: Number
  },

  data: () => ({
    loading: false,
    thesis: {
      name: '',
      text: '',
      finance: '',
      email: '',
      lit: [''],
      orgs: [],
      coautors: [],
      author: {
        fio: '', 
        org: '', 
        id: 0,
        org_id: 0,
        org_numbers: 0,
      }
    },
    authors_count: 1,
    view_thesis: '',

    add_org_dialog: false,
    organizations: [],
    valueOrganization_error: false,
    valueOrganization: '',
    checkbox_other_org: false,
    other_org_descr: '',
    text_len_error: true,
    name_len_error: true,
    email_len_error: true,

  }),

  components: {
  },

  watch: {
    // 'thesis.email'(val){
    //   console.log(this.thesis)
    // },

    'thesis.name'(val){
      this.thesis.name = val.toUpperCase()
      if(val.length > 0)
       this.name_len_error = false
      else
        this.name_len_error = true

    },

    'thesis.email'(val){
      if(val.length > 0)
       this.email_len_error = false
      else
        this.email_len_error = true

    },

    'thesis.text'(val){
      if(this.thesis.text.length < 1500)
        this.text_len_error = true
      else
        this.text_len_error = false

      var str2 = this.thesis.text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/`/g, '&#x60;');
      // str2 = str2.replace(/\n/g, '\u003cbr\u003e')


      var t = str2.replaceAll('&lt;i&gt;','<i style="font-style: italic;">')
      t = t.replaceAll('&lt;/i&gt;','</i>')
      // var t = this.thesis.text.replaceAll('<i>','<i style="font-style: italic;">')
      // console.log('thesis.text', t)
      this.view_thesis = '<p style="margin-bottom: 0px">' +  t.replace(/\n/g,'</p><p style="margin-bottom: 0px">') + '</p>'
    },

    checkbox_other_org(val){
      if(val){
        this.valueOrganization = 134
      }
      else
        if(this.valueOrganization == 134)
          this.valueOrganization = ''
    },
    valueOrganization(val){
      if(val == '134')
        this.checkbox_other_org = true
      else
        this.checkbox_other_org = false
    },
  },

  computed: {
    ...mapGetters([
      'GETTERS_ORGS',
    ]),
  },

  created() {
  },

  methods: {
    ...mapActions([
      'UPLOAD_THESIS',
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
    ]),

    add_lit(){
      if(this.thesis.lit.length < 5)
        this.thesis.lit.push('')
    },

    clear_data(){
      this.thesis= {
        name: '',
        text: '',
        finance: '',
        email: '',
        lit: [''],
        coautors: [],
        orgs: [],
        author: {
          fio: '', 
          org: '', 
          id: 0,
          org_id: 0,
          org_numbers: 0,
        }
      }
      this.authors_count = 1
      this.view_thesis = ''

    },


    add_org_to_thesis(){
      if(this.valueOrganization > 0){
        var len = this.thesis.orgs.length + 1
        if(this.valueOrganization == '134'){
          this.thesis.orgs.push({
            'id': len,
            'descr': this.other_org_descr,
            'view_descr': len + '. ' + this.other_org_descr,
            'org_id': -1
          })
        }
        else{
          var org = this.GETTERS_ORGS[this.valueOrganization] 
          this.thesis.orgs.push({
            'id': len,
            'descr': org.name,
            'view_descr': len + '. '  + org.name,
            'org_id': org.id
          })
        }
      }
      // console.log('add_org_to_thesis', this.thesis.orgs)
    },

    delete_from_orgs(deleted_pos){
      // var pos = -1
      this.thesis.orgs.splice(deleted_pos, 1)
      
      this.thesis.orgs.forEach((item, count) => {
        item.view_descr = (count+1) + '. '  + item.descr
      })
      },

    upload_thesis(){
      var has_error = false
      if(this.thesis.text.length < 1500){
        this.$messageHelper('недостаточное количество символов в тексте Тезисов', 'error', 3000);
        has_error =true
      }

      if(!this.thesis.author.org_numbers || this.thesis.author.org_numbers.length == 0){
        this.$messageHelper('Не указана организация докладчика', 'error', 3000);
        has_error =true
      }
      this.thesis.coautors.forEach(item => {
        if(!item.org_numbers || item.org_numbers.length == 0){
          this.$messageHelper('Не указана организация соавтора', 'error', 3000);
          has_error =true
        }

      })

      if(this.thesis.email.length < 5){
        this.$messageHelper('Не указан e-mail', 'error', 3000);
        has_error =true
      }
      if(this.thesis.name.length < 10){
        this.$messageHelper('Не указано название доклада', 'error', 3000);
        has_error =true
      }

      if(has_error){
        return
      }

      this.UPDATE_OVERLAY(true)
      var data = {
        current_user_registration_id: this.current_user_registration_id,
        thesis: this.thesis
      }

      this.UPLOAD_THESIS(data)
        .then((res) => {
          if (!res.data.hasOwnProperty('error')) {

            this.clear_data()
            this.$emit('updateParent', 1)

            this.$messageHelper('Тезисы успешно загружены', 'success', 3000);
          } else {
            this.$messageHelper(res.data.error, 'error', 3000);
          }
          this.UPDATE_OVERLAY(false)
        })
        .catch((e) => {
          console.log('eee', e);
          this.$messageHelper(e.message, 'error', 4000);
          this.UPDATE_OVERLAY(false)
        });

    },

    add_coautor(){
      this.thesis.coautors.push({fio: '', org: '', id: this.authors_count, org_id: 0, org_numbers: []})
      this.authors_count += 1
    },

  }

};
</script>
